import { aed } from "@/lib/format";
import {
  buildReportDocument,
  openReportPrint,
  periodMeta,
  resolveReportLetterhead,
  escapeReportHtml,
} from "@/lib/reportPrintShell";

function cell(value) {
  return value != null && value !== "" ? aed(value) : "";
}

async function buildHtml(title, report, tableHtml) {
  const company = await resolveReportLetterhead({ branchId: report?.branch_id, allBranches: report?.all_branches });
  return buildReportDocument({
    title,
    company,
    metaHtml: periodMeta(report),
    bodyHtml: tableHtml,
  });
}

export async function printCustomerReport(report) {
  if (!report) return false;
  const rows = (report.rows || [])
    .map(
      (r) => `
      <tr>
        <td>${escapeReportHtml(r.customer_code || "")}</td>
        <td>${escapeReportHtml(r.customer_name)}</td>
        <td class="mono">${escapeReportHtml(r.customer_tax_number || "")}</td>
        <td class="num">${r.bill_count}</td>
        <td class="num">${cell(r.round_off)}</td>
        <td class="num">${cell(r.net_sales)}</td>
      </tr>`,
    )
    .join("");

  const html = await buildHtml(
    "Customer Wise Sales",
    report,
    `<table>
      <thead><tr><th>Code</th><th>Customer</th><th>TRN</th><th>Bills</th><th>Round off</th><th>Net</th></tr></thead>
      <tbody>${rows}</tbody>
    </table>`,
  );
  return openReportPrint(html);
}

export async function printDeliveryPersonReport(report) {
  if (!report) return false;
  const rows = (report.rows || [])
    .map(
      (r) => `
      <tr>
        <td>${r.person_code || ""}</td>
        <td>${r.person_name}</td>
        <td class="num">${r.bill_count}</td>
        <td class="num">${cell(r.parcel_charge)}</td>
        <td class="num">${cell(r.round_off)}</td>
        <td class="num">${cell(r.net_sales)}</td>
      </tr>`,
    )
    .join("");

  const html = await buildHtml(
    "Delivery Person Wise",
    report,
    `<table>
      <thead><tr><th>Code</th><th>Driver</th><th>Bills</th><th>Parcel</th><th>Round off</th><th>Net</th></tr></thead>
      <tbody>${rows}</tbody>
    </table>`,
  );
  return openReportPrint(html);
}

export async function printDeliveryAreaReport(report) {
  if (!report) return false;
  const rows = (report.rows || [])
    .map(
      (r) => `
      <tr>
        <td>${r.area_code || ""}</td>
        <td>${r.area_name}</td>
        <td class="num">${r.bill_count}</td>
        <td class="num">${cell(r.parcel_charge)}</td>
        <td class="num">${cell(r.round_off)}</td>
        <td class="num">${cell(r.net_sales)}</td>
      </tr>`,
    )
    .join("");

  const html = await buildHtml(
    "Delivery Area Wise",
    report,
    `<table>
      <thead><tr><th>Code</th><th>Area</th><th>Bills</th><th>Parcel</th><th>Round off</th><th>Net</th></tr></thead>
      <tbody>${rows}</tbody>
    </table>`,
  );
  return openReportPrint(html);
}

export async function printOperationsReport(report, type, options = {}) {
  const withBranch = report ? { ...report, branch_id: report.branch_id ?? options.branchId, all_branches: options.allBranches } : report;
  switch (type) {
    case "customers":
      return printCustomerReport(withBranch);
    case "delivery-persons":
      return printDeliveryPersonReport(withBranch);
    case "delivery-areas":
      return printDeliveryAreaReport(withBranch);
    default:
      return false;
  }
}
